import { MissedDealFeedback } from 'components/missed-deal-feedback';
import { BlotterPanelBodyLayout } from 'components/shared/Blotter/BlotterPanel/BlotterPanelBody/BlotterPanelBodyLayout';
import { FieldValueListNext } from 'components/shared/FieldValueListNext/FieldValueListNext';
import { useBlotterPanelContext } from 'hooks/useBlotterPanelContext';
import type { BlotterPanelField } from 'models/blotters/BlotterPanelField';
import type { IBlotterItem } from 'models/IBlotterItem';
import { FC, ReactNode, useMemo } from 'react';
import { TabContainer, TabContent, TabPane } from 'react-bootstrap';

import { GenericErrorBoundary } from '../../../../common-form/builder/form/GenericErrorBoundary';
import type { BlotterPanelTabType } from '../BlotterPanelHeader/BlotterPanelHeader';

export interface BlotterPanelBodyOwnProps {
  blotterItem: IBlotterItem;
}

export interface BlotterPanelBodyStateProps {
  fields: ReadonlyArray<BlotterPanelField>;
  tabs: BlotterPanelTabType[];
}

export type BlotterPanelBodyProps = BlotterPanelBodyOwnProps & BlotterPanelBodyStateProps;

export const BlotterPanelBodyComponent: FC<BlotterPanelBodyProps> = props => {
  const { activeTab, blotterType } = useBlotterPanelContext()!;
  const { tabs } = props;

  const isOrderLimitTabVisible = useMemo(() => blotterType === 'products', [blotterType]);

  return (
    <TabContainer activeKey={activeTab}>
      <BlotterPanelBodyLayout>
        <TabContent data-e2e="tab-content" className="h-100">
          {tabs.map((tab: BlotterPanelTabType) => {
            return tab === 'ORDER_LIMIT' && !isOrderLimitTabVisible ? null : (
              <TabPane eventKey={tab} key={tab} className="h-100" data-e2e="tab-pane">
                <GenericErrorBoundary key={tab}>{getTabBody(tab, tab === activeTab, props)}</GenericErrorBoundary>
              </TabPane>
            );
          })}
        </TabContent>
      </BlotterPanelBodyLayout>
    </TabContainer>
  );
};

function getTabBody(
  tabType: BlotterPanelTabType,
  isSelected: boolean,
  props: Omit<BlotterPanelBodyProps, 'tabs'>,
): ReactNode {
  switch (tabType) {
    case 'SUMMARY':
      return <FieldValueListNext fields={props.fields} blotterItem={props.blotterItem} />;
    case 'MISSED_DEAL_FEEDBACK':
      return isSelected ? (
        <div className="d-flex flex-column h-100">
          <MissedDealFeedback formId={props.blotterItem.quoteId} />
        </div>
      ) : null;
    case 'ORDER_LIMIT':
      return 'ORDER_LIMIT';
  }
}
